import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { useAdminAuth } from "@/lib/admin-auth";
import { AppLayout } from "@/components/AppLayout";
import { Loading } from "@/components/States";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="min-h-screen bg-background"><Loading label="Loading workshop…" /></div>;
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  // Unverified accounts are blocked from every protected page until they verify.
  if (user.email_verified === false && location.pathname !== "/verify-email") {
    return <Navigate to="/verify-email" replace />;
  }
  // Subscription gate: a garage without a valid subscription/trial must select a
  // plan + complete Stripe Checkout first. has_app_access is verified server-side
  // (/auth/me reads the garage's real subscription); billing/verify pages stay open
  // so there is no redirect loop. Undefined (legacy payloads) is treated as allowed
  // because the backend still enforces access on every API.
  const subAllowed = location.pathname === "/billing" || location.pathname === "/verify-email";
  if (user.has_app_access === false && !subAllowed) {
    return <Navigate to="/billing" replace />;
  }
  return <AppLayout>{children}</AppLayout>;
}

export function AdminProtectedRoute({ children }) {
  const { admin, loading } = useAdminAuth();
  if (loading) return <div className="min-h-screen bg-midnight"><Loading label="Loading…" /></div>;
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
}
